import React from 'react';
import { NSCard } from 'bricks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faGreaterThan, faLessThan } from '@fortawesome/free-solid-svg-icons';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import './UsesVsSourcesCard.scss';

export interface IUsesVsSourcesCardProps {
    usesTotal: number;
    sourcesTotal: number;
}

const UsesVsSourcesCard = ({ usesTotal, sourcesTotal }: IUsesVsSourcesCardProps) => {
    const getComparisonIcon = () => {
        if (usesTotal > sourcesTotal) {
            return faGreaterThan;
        }
        if (usesTotal < sourcesTotal) {
            return faLessThan;
        }
        return faChevronRight;
    };

    return (
        <NSCard className="UsesVsSourcesCard my-0 shadow-none text-dark">
            <div className="d-flex align-items-center px-2 font-12 my-1">
                <div>
                    <div className="font-weight-bold">Uses</div>
                    <div className="">{numeralFormatterCurrency(usesTotal)}</div>
                </div>
                <FontAwesomeIcon
                    className="icon mx-4"
                    icon={getComparisonIcon()}
                    fixedWidth
                    size="sm"
                />
                <div>
                    <div className="font-weight-bold">Sources</div>
                    <div>{numeralFormatterCurrency(sourcesTotal)}</div>
                </div>
            </div>
        </NSCard>
    );
};

export default UsesVsSourcesCard;
